<template lang="pug">
    .validating-header
        h2 {{name}}
        .validating-header__actions
            p.validating-header__name Проверяющие
            ButtonGroups
</template>
<script>
import ButtonGroups from './components/ButtonGroups';

export default {
  name: 'Header',
  components: {
    ButtonGroups
  },
  props: {
    value: {},
    name: {}
  }
};
</script>
